import { IPD_LOAD_DATA } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface IPDConfigReponse {
    success: boolean;
    data: Data;
}
export interface Data {
    beds?: BedsEntity[] | null;
    rooms?: RoomsEntity[] | null;
    categories?: CategoriesEntity[] | null;
    rateplans?: RateplansEntity[] | null;
    rateplaninclusions?: RateplaninclusionsEntity[] | null;
}
export interface BedsEntity {
    updatedAt: string;
    room: string;
    name: string;
    id: string;
}
export interface RoomsEntity {
    updatedAt: string;
    category: string;
    name: string;
    id: string;
}
export interface CategoriesEntity {
    updatedAt: string;
    description: string;
    name: string;
    id: string;
}
export interface RateplansEntity {
    updatedAt: string;
    name: string;
    id: string;
}
export interface RateplaninclusionsEntity {
    rate: number;
    name: string;
    plan: string;
    id: string;
}

export default (from?: string): Promise<IPDConfigReponse> => {
    return fetchWithRefresh(IPD_LOAD_DATA(from), {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
